// deps
import React from "react";
import cx from "classnames";
// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";

import styles from "../PaymentGroup.v4.scss";

export default function PaymentGroupContainer(props: {
    children: React.ReactNode;
    className?: string;
    isFrictionPage?: boolean;
}): React.ReactElement {
    return (
        <div
            className={cx(styles.paymentGroup, props.className, {
                [styles.paymentGroupFrictionGroup]: props.isFrictionPage,
            })}
            data-testid={PAYMENT_GROUP_TEST_IDS.CONTAINER}
        >
            {props.children}
        </div>
    );
}
